@if (data?.options?.type === 'h1') {
  <h1
    class="max-width"
    [class.contrast]="data?.options?.contrast">
    {{ data?.content?.text }}
  </h1>
}
@if (data?.options?.type === 'h3') {
  <h3
    class="max-width"
    [class.contrast]="data?.options?.contrast">
    {{ data?.content?.text }}
  </h3>
}
@if (data?.options?.type === 'h4') {
  <h4
    class="max-width"
    [class.contrast]="data?.options?.contrast">
    {{ data?.content?.text }}
  </h4>
}
